var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "cmp cmp-product-thumb" }, [
    _c(
      "div",
      {
        staticClass: "position-relative",
        class: _vm.paddingClasses,
        style: _vm.paddingInlineStyles
      },
      [
        _c("add-to-basket", {
          attrs: {
            "variation-id": _vm.item.variation.id,
            "is-salable": !!_vm.item.filter && _vm.item.filter.isSalable,
            "has-children":
              !!_vm.item.item && _vm.item.item.salableVariationCount > 1,
            "interval-quantity": _vm.item.variation.intervalOrderQuantity || 1,
            "minimum-quantity": _vm.item.variation.minimumOrderQuantity,
            "maximum-quantity":
              !!_vm.item.variation.maximumOrderQuantity &&
              _vm.item.variation.maximumOrderQuantity > 0
                ? _vm.item.variation.maximumOrderQuantity
                : null,
            "order-properties": _vm.item.properties.filter(function(prop) {
              return prop.property.isOderProperty
            }),
            "has-required-order-property": _vm.item.hasRequiredOrderProperty,
            "has-order-properties": _vm.item.hasOrderProperties,
            "use-large-scale": true,
            "show-quantity": false,
            "item-url": _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
            "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
            "has-graduated-price":
              _vm.itemGraduatedPriceisCheapestSorting ||
              _vm.itemGraduatedPricesalableVariationCount,
            "item-type": _vm.item.item.itemType
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "thumb-image" }, [
          _c("div", { staticClass: "prop-1-1" }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                }
              },
              [
                _vm.position < 3
                  ? _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        src: _vm.item.images.all[0].urlMiddle,
                        title: _vm._f("itemName")(_vm.item),
                        alt: _vm._f("itemName")(_vm.item)
                      }
                    })
                  : _c("lazy-img", {
                      attrs: {
                        "image-url": _vm.item.images.all[0].urlMiddle,
                        title: _vm._f("itemName")(_vm.item),
                        alt: _vm._f("itemName")(_vm.item),
                        "picture-class": "img-fluid"
                      }
                    })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _vm._t("store-special", function() {
          return [
            _vm.storeSpecial
              ? _c("item-store-special", {
                  attrs: {
                    "store-special": _vm.storeSpecial,
                    "recommended-retail-price": _vm.item.prices.rrp,
                    "variation-retail-price": _vm.item.prices.default,
                    "special-offer-price": _vm.item.prices.specialOffer,
                    "decimal-count": _vm.decimalCount,
                    "bundle-type": _vm.item.variation.bundleType,
                    "item-type": _vm.item.item.itemType
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.item.variation.availability.id === 5
              ? _c("div", { staticClass: "special-tags p-2" }, [
                  _c(
                    "span",
                    { staticClass: "badge badge-offer badge-danger" },
                    [_vm._v("Kommt wieder")]
                  )
                ])
              : _vm._e()
          ]
        }),
        _vm._v(" "),
        _vm._t("item-details", function() {
          return [
            _c("div", { staticClass: "thumb-content" }, [
              _c(
                "a",
                {
                  staticClass: "thumb-title text-secondary",
                  attrs: {
                    href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.texts.name3 && _vm.texts.name3 != "N / A"
                          ? _vm.texts.name3
                          : _vm.texts.name1
                      )
                  ),
                  _vm._l(_vm.item.groupedAttributes, function(attribute) {
                    return _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("translate")(
                            "Ceres::Template.itemGroupedAttribute",
                            attribute
                          )
                        )
                      )
                    ])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "small thumb-subtitle",
                  attrs: {
                    href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                  }
                },
                [
                  _vm._l(_vm.item.attributes, function(attribute, index1) {
                    return _vm.$ceres.themeConfig.sizeAttributesId.includes(
                      attribute.attributeId
                    )
                      ? _c(
                          "span",
                          [
                            _c("i", {
                              staticClass: "fa fa-check",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" versch. Größen\n                    "),
                            _vm._l(_vm.item.attributes, function(
                              attribute,
                              index1
                            ) {
                              return _vm.$ceres.themeConfig.paintingAttributesId.includes(
                                attribute.attributeId
                              )
                                ? _c("span", [
                                    _vm._v(
                                      "\n                       & Ausführungen\n                    "
                                    )
                                  ])
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm.item.hasOrderProperties
                    ? _c("span", { staticClass: "green" }, [
                        _c("i", {
                          staticClass: "fa fa-edit",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" personalisierbar\n                ")
                      ])
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "thumb-meta" }, [
                _c(
                  "div",
                  { staticClass: "price-wrapper" },
                  [
                    _vm._t("before-prices"),
                    _vm._v(" "),
                    _c("div", { staticClass: "prices" }, [
                      _vm.item.prices.rrp &&
                      _vm.item.prices.rrp.price.value > 0 &&
                      _vm.item.prices.rrp.price.value >
                        _vm.item.prices.default.unitPrice.value
                        ? _c("div", { staticClass: "price-view-port" }, [
                            _vm.item.prices.specialOffer
                              ? _c("del", { staticClass: "crossprice" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.item.prices.default.unitPrice
                                          .formatted
                                      ) +
                                      "\n                                "
                                  )
                                ])
                              : _c("del", { staticClass: "crossprice" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.item.prices.rrp.unitPrice.formatted
                                      ) +
                                      "\n                                "
                                  )
                                ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "price" },
                        [
                          _vm.item.item.itemType === "set"
                            ? [
                                _vm._v(
                                  "\n                                  " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemSetPrice",
                                        { price: _vm.itemSetPrice }
                                      )
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.categoryItemFootnote"
                                      )
                                    ) +
                                    "\n                                "
                                )
                              ]
                            : _vm.itemGraduatedPriceisCheapestSorting
                            ? [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.categoryItemFromPrice",
                                        { price: _vm.itemPriceGraduated }
                                      )
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.categoryItemFootnote"
                                      )
                                    ) +
                                    "\n                              "
                                )
                              ]
                            : _vm.itemGraduatedPricesalableVariationCount
                            ? [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.categoryItemFromPrice",
                                        { price: _vm.itemPriceGraduated }
                                      )
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.categoryItemFootnote"
                                      )
                                    ) +
                                    "\n                                "
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n                                  " +
                                    _vm._s(
                                      _vm.item.prices.default.unitPrice
                                        .formatted
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.categoryItemFootnote"
                                      )
                                    ) +
                                    "\n                                "
                                )
                              ]
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    !(
                      _vm.item.unit.unitOfMeasurement === "C62" &&
                      _vm.item.unit.content === 1
                    )
                      ? _c(
                          "div",
                          { staticClass: "category-unit-price small" },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.item.unit.names.name))
                            ]),
                            _vm._v(" "),
                            _vm.item.variation.mayShowUnitPrice
                              ? _c("span", [
                                  _vm._v(" | " + _vm._s(_vm.basePrice))
                                ])
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.prices.default.lowestPrice.value &&
                    _vm.hasCrossPrice
                      ? _c(
                          "div",
                          { staticClass: "category-lowest-price small" },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.categoryItemLowestPrice",
                                    {
                                      price:
                                        _vm.item.prices.default.lowestPrice
                                          .formatted
                                    }
                                  )
                                )
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._t("after-prices")
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "add-to-wishlist-wrapper" },
                  [
                    _c("add-to-wish-list", {
                      attrs: { "variation-id": _vm.item.variation.id }
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }